// extracted by mini-css-extract-plugin
export var chevronIcon = "_sf-1";
export var edgeToggle = "_sf-0";